import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=49fb9fad&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=49fb9fad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb9fad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fb9fad')) {
      api.createRecord('49fb9fad', component.options)
    } else {
      api.reload('49fb9fad', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=49fb9fad&scoped=true&", function () {
      api.rerender('49fb9fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IAVyz2XvJ3DO/JS/comp/PopupBox.vue"
export default component.exports